import { toast } from "react-toastify";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";

export const getDenunciasPorAprobar = async (setInfraccionesNuevas, estadoId) => {
  const result = await axios().get("get_denuncias_para_aprobar", {
    params: {
      estado_id: estadoId,
    },
  });
  const { data, error } = result.data;

  if (data) {
    setInfraccionesNuevas((prevState) => ({
      ...prevState,
      infraccion_seleccionada: null,
      loading: false,
      data: data,
    }));
  }

  if (error) {
    toast.error(error, toastOptions);
  }
};
